import React from "react";
import { MainLayout } from "../components/Common/MainLayout/mainlayout";
import { AuthenticationLayout } from "../components/Common/AuthLayout/AuthenticationLayout";
import { SignUpContent } from "../components/Authentication/SignUpContent";
import { SignInContent } from "../components/Authentication/SignInContent";
import { LockScreenContent } from "../components/Authentication/LockScreenContent";
import { LogOutContent } from "../components/Authentication/LogOutContent";
import { PasswordChangeContent } from "../components/Authentication/PasswordChangeContent";
import { PasswordResetContent } from "../components/Authentication/PasswordResetContent";
import { SuccessMsgContent } from "../components/Authentication/SuccessMsgContent";
import { ErrorPageContent } from "../components/Authentication/ErrorPageContent";
import { ErrorPageContentOne } from "../components/Authentication/ErrorPageContentOne";
import { TwoStepAuthContent } from "../components/Authentication/TwoStepAuthContent";
import { OfflinePageContent } from "../components/Authentication/OfflinePageContent";
import { PageGroup } from "../pages/PageGroup";
import { PageMaster } from "../pages/PageMaster";
import { CreateRoles } from "../pages/CreateRoles";
import { ManageAccessPage } from "../pages/ManageAccess";
import AuthProtected from "./AuthProtected";
import PublicRoute from "./PublicRoute";
import { NewUser } from "../pages/NewUser";
import { NewUserView } from "../pages/NewUserView";
import { NewUserUpdate } from "../pages/NewUserUpdate";
import { ProfilePage } from "../pages/profilePage";
import { ChangePassword } from "../pages/ChangePassword";
import { DashboardPage } from "../pages/dashboardPage";
import { Navigate } from "react-router-dom";
import { UserDashboardPage } from "../pages/UserDashboardPage";
import { AddCategoryPage } from "../pages/Category/AddCategoryPage";
import { ViewCategoryPage } from "../pages/Category/ViewCategoryPage";
import { UpdateCategoryPage } from "../pages/Category/UpdateCategoryPage";
import { ViewSubCategoryPage } from "../pages/SubCategory/ViewSubCategoryPage";
import { AddSubCategoryPage } from "../pages/SubCategory/AddSubCategoryPage";
import { UpdateSubCategoryPage } from "../pages/SubCategory/UpdateSubCategoryPage";
import { ViewBrandPage } from "../pages/Brand/ViewBrandPage";
import { AddBrandPage } from "../pages/Brand/AddBrandPage";
import { UpdateBrandPage } from "../pages/Brand/UpdateBrandPage";
import { ViewTagPage } from "../pages/Tag/ViewTagPage";
import { AddTagPage } from "../pages/Tag/AddTagPage";
import { UpdateTagPage } from "../pages/Tag/UpdateTagPage";
import { ViewBlogPage } from "../pages/Blog/ViewBlogPage";
import { AddBlogPage } from "../pages/Blog/AddBlogPage";
import { UpdateBlogPage } from "../pages/Blog/UpdateBlogPage";
import { ViewBannerPage } from "../pages/Banner/ViewBannerPage";
import { AddBannerPage } from "../pages/Banner/AddBannerPage";
import { UpdateBannerPage } from "../pages/Banner/UpdateBannerPage";
import { ManageHSNCodePage } from "../pages/HSNCode/ManageHSNCodePage";
import { AddProductPage } from "../pages/Product/AddProductPage";
import { ViewProductPage } from "../pages/Product/ViewProductPage";
import { UpdateProductPage } from "../pages/Product/UpdateProductPage";
import { ManageProductFaqPage } from "../pages/Product/ManageProductFaqPage";
import { ManageProductVariantPage } from "../pages/Product/ManageProductVariantPage";
import { ManageCouponCodePage } from "../pages/Coupon/ManageCouponCodePage";
import { ViewMarketingBannerPage } from "../pages/MarketingBanner/ViewMarketingBannerPage";
import { AddMarketingBannerPage } from "../pages/MarketingBanner/AddMarketingBannerPage";
import { UpdateMarketingBannerPage } from "../pages/MarketingBanner/UpdateMarketingBannerPage";
import { ViewTestimonialPage } from "../pages/Testimonial/ViewTestimonialPage";
import { AddTestimonialPage } from "../pages/Testimonial/AddTestimonialPage";
import { UpdateTestimonialPage } from "../pages/Testimonial/UpdateTestimonialPage";
import { ViewProductVariantPage } from "../pages/Product/ViewProductVariantPage";
import { ViewEmailSubscribePage } from "../pages/Requests/ViewEmailSubscribePage";
import { ViewContactRequestPage } from "../pages/Requests/ViewContactRequestPage";
import { ViewNotifyUserPage } from "../pages/Requests/ViewNotifyUserPage";
import { ViewProductReviewPage } from "../pages/Reviews/ViewProductReviewPage";
import { ReArrangeCategoryPage } from "../pages/Category/ReArrangeCategoryPage";
import { ReArrangeSubCategoryPage } from "../pages/SubCategory/ReArrangeSubCategoryPage";
import { ReArrangeBrandPage } from "../pages/Brand/ReArrangeBrandPage";
import { ReArrangeProductPage } from "../pages/Product/ReArrangeProductPage";
import { ViewCustomerPage } from "../pages/Customers/ViewCustomerPage";
import { ViewOrderReportPage } from "../pages/Reports/ViewOrderReportPage";
import { ViewOrderDetailPage } from "../pages/Reports/ViewOrderDetailPage";
import { ViewOrderInvoiceDetailPage } from "../pages/Reports/ViewOrderInvoiceDetailPage";
import { ManageAppSettingPage } from "../pages/ManageAppSettingPage";
import { ViewTagCollectionPage } from "../pages/TagCollection/ViewTagCollectionPage";
import { UpdateTagCollectionPage } from "../pages/TagCollection/UpdateTagCollectionPage";
import { AddTagCollectionPage } from "../pages/TagCollection/AddTagCollectionPage";
import { ManageSupplierPage } from "../pages/Suppliers/ManageSupplierPage";

 
const routes = [
  {
    path: "/",
    element: (
      <AuthProtected>
        <MainLayout />
      </AuthProtected>
    ),
    children: [
      { path: "/", element: <Navigate to="/dashboard" replace /> },
      { path: "page-group", element: <PageGroup /> },
      { path: "page-master", element: <PageMaster /> },
      { path: "create-role", element: <CreateRoles /> },
      { path: "app-setting", element: <ManageAppSettingPage /> },
      {
        path: "Manage-role-access/:roleId/:roleName",
        element: <ManageAccessPage />,
      },
      { path: "dashboard", element: <DashboardPage /> },
      { path: "user-dashboard", element: <UserDashboardPage /> },
      { path: "my-profile", element: <ProfilePage /> },
      { path: "change-password", element: <ChangePassword /> },
      //routing for user management
      { path: "user", element: <NewUserView /> },
      {
        path: "user",
        children: [
          { path: "add", element: <NewUser /> },
          { path: "update/:id", element: <NewUserUpdate /> },
        ],
      },
      //routing for brand management
      { path: "brand", element: <ViewBrandPage /> },
      {
        path: "re-arrange-brand",
        element: <ReArrangeBrandPage />,
      },
      {
        path: "brand",
        children: [
          { path: "add", element: <AddBrandPage /> },
          { path: "update/:id", element: <UpdateBrandPage /> },
        ],
      },
      //--------------------------

      //routing for tag management
      { path: "tag", element: <ViewTagPage /> },
      {
        path: "tag",
        children: [
          { path: "add", element: <AddTagPage /> },
          { path: "update/:id", element: <UpdateTagPage /> },
        ],
      },
      //--------------------------

      //routing for tag collection management
      { path: "tag-collection", element: <ViewTagCollectionPage /> },
      {
        path: "tag-collection",
        children: [
          { path: "add", element: <AddTagCollectionPage /> },
          { path: "update/:id", element: <UpdateTagCollectionPage /> },
        ],
      },
      //--------------------------

      //routing for category management

      { path: "category", element: <ViewCategoryPage /> },
      {
        path: "re-arrange-category",
        element: <ReArrangeCategoryPage />,
      },
      {
        path: "category",
        children: [
          { path: "add", element: <AddCategoryPage /> },
          { path: "update/:id", element: <UpdateCategoryPage /> },
        ],
      },
      //--------------------------

      //routing for category management
      { path: "sub-category", element: <ViewSubCategoryPage /> },
      {
        path: "re-arrange-sub-category",
        element: <ReArrangeSubCategoryPage />,
      },
      {
        path: "sub-category",
        children: [
          { path: "add", element: <AddSubCategoryPage /> },
          { path: "update/:id", element: <UpdateSubCategoryPage /> },
        ],
      },
      //--------------------------

      //routing for blog management
      { path: "blog", element: <ViewBlogPage /> },
      {
        path: "blog",
        children: [
          { path: "add", element: <AddBlogPage /> },
          { path: "update/:id", element: <UpdateBlogPage /> },
        ],
      },
      //--------------------------

      //routing for banner management
      { path: "banner", element: <ViewBannerPage /> },
      {
        path: "banner",
        children: [
          { path: "add", element: <AddBannerPage /> },
          { path: "update/:id", element: <UpdateBannerPage /> },
        ],
      },
      //--------------------------

      //routing for marketing banner management
      { path: "marketing-banner", element: <ViewMarketingBannerPage /> },
      {
        path: "marketing-banner",
        children: [
          { path: "add", element: <AddMarketingBannerPage /> },
          { path: "update/:id", element: <UpdateMarketingBannerPage /> },
        ],
      },
      //--------------------------

      //routing for testimonial management
      { path: "testimonial", element: <ViewTestimonialPage /> },
      {
        path: "testimonial",
        children: [
          { path: "add", element: <AddTestimonialPage /> },
          { path: "update/:id", element: <UpdateTestimonialPage /> },
        ],
      },
      //--------------------------
      //routing for HSN Code management
      { path: "hsn-code", element: <ManageHSNCodePage /> },
      //--------------------------
      //routing for suppliers management
       { path: "supplier-master", element: <ManageSupplierPage /> },
      //routing for Coupon Code management
      { path: "coupon", element: <ManageCouponCodePage /> },
      //--------------------------
      //routing for product management
      { path: "product", element: <ViewProductPage /> },
      {
        path: "re-arrange-product",
        element: <ReArrangeProductPage />,
      },
      {
        path: "product",
        children: [
          { path: "add", element: <AddProductPage /> },
          { path: "update/:id", element: <UpdateProductPage /> },
          { path: ":productId/faq", element: <ManageProductFaqPage /> },
          { path: ":productId/variant", element: <ManageProductVariantPage /> },
        ],
      },
      //--------------------------
      //routing for product variant management
      { path: "product/variants", element: <ViewProductVariantPage /> },
      //--------------------------
      //--------------------------
      //routing for email subscribe management
      { path: "email-subscribe", element: <ViewEmailSubscribePage /> },
      //--------------------------
      //routing for contact request management
      { path: "contact-request", element: <ViewContactRequestPage /> },
      //--------------------------
      //routing for notify user management
      { path: "notify-user", element: <ViewNotifyUserPage /> },
      //--------------------------
      //routing for product review management
      { path: "product-review", element: <ViewProductReviewPage /> },
      //--------------------------
      //--------------------------
      //routing for customer management
      { path: "customer", element: <ViewCustomerPage /> },
      //--------------------------
      //routing for order reposrt
      { path: "order", element: <ViewOrderReportPage /> },
      { path: "order/:id", element: <ViewOrderDetailPage /> },
      { path: "order/invoice/:id", element: <ViewOrderInvoiceDetailPage /> },

      //--------------------------
      // { path: 'vacant-flat-report/:status', element: <ManageReportsFlats/> }
    ],
  },
  {
    path: "/auth",
    element: (
      <PublicRoute>
        <AuthenticationLayout />
      </PublicRoute>
    ),
    children: [
      { path: "signup", element: <SignUpContent /> },
      { path: "signin", element: <SignInContent /> },
      { path: "lock-screen", element: <LockScreenContent /> },
      { path: "logout", element: <LogOutContent /> },
      { path: "password-change", element: <PasswordChangeContent /> },
      { path: "password-reset", element: <PasswordResetContent /> },
      { path: "success-message", element: <SuccessMsgContent /> },
      { path: "verification", element: <TwoStepAuthContent /> },
    ],
  },

  {
    path: "/500-error-page",
    element: <ErrorPageContentOne />,
  },
  { path: "404-error-page", element: <ErrorPageContent /> },
  {
    path: "/offline",
    element: <OfflinePageContent />,
  },
];

export default routes;
